import { cn } from "@/lib/utils";
import { ErrorLbl, Input, InputContainer, InputLbl } from "./styles";

interface IInputLabel {
  label?: string;
  placeholder?: string;
  value: string;
  setValue: (value: string) => void;
  type?: "text" | "email" | "password" | "number";
  required?: boolean;
  error?: boolean;
  disabled?: boolean;
  min?: number;
  name?: string;
  className?: string;
  errorMessage?: string;
  readonly?: boolean;
  maxLength?: number; // Propriedade opcional para quantidade máxima de caracteres
}

export const InputLabel: React.FC<IInputLabel> = ({
  label,
  placeholder,
  setValue,
  type = "text",
  value,
  className,
  disabled = false,
  name,
  min,
  required = false,
  error = false,
  errorMessage = "Inválido.",
  readonly = false,
  maxLength
}) => {
  return (
    <InputLbl className={cn("relative", className)}>
      <span className="lbl"> {label}</span>
      <InputContainer
        className={cn("h-[40px] box-border", {
          "-mt-1": label === undefined
        })}
      >
        <Input
          type={type}
          value={value}
          className={cn("w-full", {
            "text-muted-foreground !text-zinc-500": disabled
          })}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          required={required}
          readOnly={readonly}
          disabled={disabled}
          min={min}
          name={name}
          maxLength={maxLength} // Aplicação da propriedade maxLength
          style={{
            border: error ? "1px solid red" : "1px solid black",
            outline: "none"
          }}
        />
      </InputContainer>

      {error && (
        <ErrorLbl className="absolute left-0 bottom-0 -mb-4 mobile:-mb-4">
          {errorMessage}
        </ErrorLbl>
      )}
    </InputLbl>
  );
};
